/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_Pit2_TInputs */

const en_sorter_pit2_t = /** @type {(inputs: Sorter_Pit2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorted output is not a portable canonical form`)
};

const ko_sorter_pit2_t = /** @type {(inputs: Sorter_Pit2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`정렬된 출력은 이식 가능한 정규형이 아닙니다`)
};

const ja_sorter_pit2_t = /** @type {(inputs: Sorter_Pit2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`並べ替えた出力は移植可能な正規形ではありません`)
};

/**
* | output |
* | --- |
* | "Sorted output is not a portable canonical form" |
*
* @param {Sorter_Pit2_TInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_pit2_t = /** @type {((inputs?: Sorter_Pit2_TInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_Pit2_TInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_pit2_t(inputs)
	if (locale === "ko") return ko_sorter_pit2_t(inputs)
	return ja_sorter_pit2_t(inputs)
});